import { LocationPoint, WorldMapPointKind } from "@/types/location"

export function playRouteForMapPoint(
  point: LocationPoint | undefined,
  pointId: string
): string {
  const kind: WorldMapPointKind = point?.mapKind ?? "scan"
  const q = `pointId=${encodeURIComponent(pointId)}`

  switch (kind) {
    case "boss":
    case "worldboss":
      return `/play/boss-map?${q}`
    case "cardshop":
      return `/play/card-shop?${q}`
    case "boostershop":
      return `/play/booster-shop?${q}`
    case "postoffice":
      return `/play/post-office?${q}`
    case "bank":
      return `/play/bank?${q}`
    case "cityhall":
      return `/play/city-hall?${q}`
    case "treasure":
      return `/play/treasure?${q}`
    case "hangar":
      return `/play/hangar?${q}`
    case "hotel":
      return `/play/hotel?${q}`
    case "wisetree":
      return `/play/wise-tree?${q}`
    default:
      return `/play/location-scan?${q}`
  }
}
